import React, { Fragment, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { vcmComponentStatusOptions } from './options';

const VcmSummary = (props) => {
  const { classes, vcm, unitResponses, vcmQualifications } = props;

  const responseCounts = useMemo(() => {
    return Object.keys(vcmComponentStatusOptions)
      .map((status) => ({
        status,
        count: unitResponses.filter((unit) => unit.status === status).length
      }))
      .filter(({ count }) => count > 0);
  }, [unitResponses]);

  const qualificationCounts = useMemo(() => {
    return Object.keys(vcmComponentStatusOptions)
      .map((status) => ({
        status,
        count: vcmQualifications.filter((qualification) => qualification.status === status).length
      }))
      .filter(({ count }) => count > 0);
  }, [vcmQualifications]);

  if (!vcm) {
    return null;
  }

  return (
    <Fragment>
      <div className={classes.unitsCountsContainer}>
        <Typography color="primary">
          Units Total: {unitResponses.length}
        </Typography>
        {responseCounts.map(({ status, count }) => (
          <Typography key={status} color="primary">
            {vcmComponentStatusOptions[status]?.label ?? status}: {count}
          </Typography>
        ))}
      </div>

      <div className={classes.unitsCountsContainer}>
        <Typography color="primary">
          Qualifications Total: {vcmQualifications.length}
        </Typography>
        {qualificationCounts.map(({ status, count }) => (
          <Typography key={status} color="primary">
            {vcmComponentStatusOptions[status]?.label ?? status}: {count}
          </Typography>
        ))}
      </div>

      <Typography color="primary">Revision {vcm.revision_text}</Typography>
      <Typography color="primary">Approver: {vcm.approver_user?.full_name ?? "UNKNOWN"}</Typography>

    </Fragment>
  );
};

export default VcmSummary;
